import { Minus, Plus } from "lucide-react";
interface Props {
    item: {
        image: string;
        title: string;
        id: number;
        quantity: number;
        price: number;
    };
    updateQuantity: (id: number, quantity: number) => void;
}
const AccessorieStepCard = ({ item, updateQuantity }: Props) => {
    return (
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 mb-4 hover:shadow-md transition-all duration-200">
            <div className="flex items-center gap-6">
                {/* Product Image */}
                <div className="flex-shrink-0">
                    <div className="w-24 h-24 bg-gray-50 rounded-lg overflow-hidden flex items-center justify-center">
                        <img
                            src={item.image}
                            className="w-full h-full object-contain"
                            alt={item.title}
                        />
                    </div>
                </div>

                {/* Product Info */}
                <div className="flex-grow">
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">
                        {item.title}
                    </h3>
                    <div className="flex items-baseline gap-1">
                        <span className="text-xl font-bold text-gray-900">
                            {item.price}€
                        </span>
                        <span className="text-sm text-gray-500">(excl. VAT)</span>
                    </div>
                </div>

                {/* Quantity Controls */}
                <div className="flex-shrink-0">
                    <div className="flex items-center bg-gray-50 rounded-full border border-gray-200 p-1">
                        <button
                            onClick={() => updateQuantity(item.id, -1)}
                            disabled={item.quantity <= 0}
                            className="w-8 h-8 rounded-full flex items-center justify-center hover:bg-white hover:shadow-sm transition-all duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            <Minus className="w-4 h-4 text-gray-600" />
                        </button>

                        <div className="w-12 text-center">
                            <span className="text-lg font-semibold text-gray-900">
                                {item.quantity || 0}
                            </span>
                        </div>

                        <button
                            onClick={() => updateQuantity(item.id, 1)}
                            className="w-8 h-8 rounded-full flex items-center justify-center hover:bg-white hover:shadow-sm transition-all duration-150"
                        >
                            <Plus className="w-4 h-4 text-gray-600" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccessorieStepCard;
